import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../../../../Contexts/AuthProvider';
import LayoutProvider from '../../../../../../Contexts/LayoutProvider';
import { useTemplate } from '../../../../../../features/template/TemplateProvider';
import { ApiAddPermission, ApiRemovePermission } from '../../../../AdminsPageOperation';
import { useAdminInfo } from '../../../AdminInfoProvider';
import TableMobile from './TableMobile';
import TableWeb from './TableWeb';

function PermissionTable({ permissions, pageLoading }) {
    const { setAdminInfoData } = useAdminInfo();
    const [loading, setLoading] = useState(false);
    const { setMessage } = useTemplate();
    const { authStateUpdated, authInfo } = useAuth();
    const { userID } = useParams();

    const handleToggle = (item) => {
        if (item.status) {
            setLoading(true);
            ApiRemovePermission(userID, item.key)
                .then(({ title, data }) => {
                    setLoading(false);
                    setMessage({ type: 'success', text: title });
                    authStateUpdated();
                    setAdminInfoData((cuDAta) => {
                        return {
                            ...cuDAta,
                            permissions: data.permissions
                        };
                    });
                })
                .catch((error) => {
                    setLoading(false);
                    setMessage({ type: 'error', text: error.toString(0) });
                });
        } else {
            setLoading(true);
            ApiAddPermission(userID, {
                userId: userID,
                key: item?.key
            })
                .then(({ title, data }) => {
                    setLoading(false);
                    setMessage({ type: 'success', text: title });
                    authStateUpdated();
                    setAdminInfoData((cuDAta) => {
                        return {
                            ...cuDAta,
                            permissions: data.permissions
                        };
                    });
                })
                .catch((error) => {
                    setLoading(false);
                    setMessage({ type: 'error', text: error.toString(0) });
                });
        }
    };
    return (
        <LayoutProvider>
            <TableWeb
                layout="default"
                permissions={permissions}
                handleToggle={handleToggle}
                pageLoading={pageLoading}
                loading={loading}
                isDisabled={authInfo?.data?.id === Number(userID)}
            />
            <TableMobile
                layout={['md', 'sm', 'xs', 'xxs']}
                permissions={permissions}
                handleToggle={handleToggle}
                pageLoading={pageLoading}
                loading={loading}
            />
        </LayoutProvider>
    );
}

export default PermissionTable;
